<template>
  <div class="bg">
    <div class="container pt-4">
      <div class="card p-2">
        <img class="img-fluid" src="../assets/banner.jpg" alt />
        <div class="form-row align-items-center d-flex justify-content-center mt-2">
          <div class="col-auto">
            <label class="sr-only" for="inlineFormInput">輸入活動名稱</label>
            <input
              type="text"
              class="form-control mb-2"
              id="inlineFormInput"
              placeholder="輸入活動名稱"
              v-model="searchKey"
            />
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-primary mb-2 mr-2" @click="onSearch">搜尋</button>
            <button type="button" class="btn btn-success mb-2" @click="onClearSearch">顯示全部</button>
          </div>
          <div class="col-auto">
            共 {{filterDatas.length}} 場活動
          </div>
        </div>
        <table class="table table-hover text-left border">
          <thead>
            <tr class="bg-info text-white">
              <th class="d-none d-md-table-cell">編號</th>
              <th class="d-none d-md-table-cell">主辦單位</th>
              <th>活動名稱</th>
              <th class="d-none d-md-table-cell">報名期間</th>
              <th>活動日期/期間</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filterDatas" :key="index" @click="onLink(item.id)">
              <td class="d-none d-md-table-cell">{{item.id}}</td>
              <td class="d-none d-md-table-cell">{{item.mainUnit}}</td>
              <td>
                <span class="text-primary font-weight-bold">{{item.name}}</span>
              </td>
              <td class="d-none d-md-table-cell">{{getDate(item.signBeginDate, item.signEndDate)}}</td>
              <td>{{getDate(item.actBeginDate, item.actEndDate)}}</td>
            </tr>
          </tbody>
        </table>
        <p>© Copyright 東南科技大學 TUNGNAN UNIVERSITY.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      listDatas: [],
      filterDatas: [],
      searchKey: '',
    };
  },
  created: function() {
    axios
      .get("http://qna.tnu.edu.tw/json/json.jsp")
      .then(response => {
        response.data = response.data.sort(function(a, b) {
          return a.id > b.id ? 1 : -1;
        });
        this.listDatas = response.data;
        this.filterDatas = this.listDatas;
        // console.log(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    getDate: function(beginDate, endDate) {
      if (beginDate === endDate) {
        return beginDate;
      } else {
        return beginDate + "~" + endDate;
      }
    },
    onLink: function(id) {
      window.open(`http://qna.tnu.edu.tw/portfolio/actview.html?id=${id}`);
    },
    onSearch: function() {
      this.filterDatas = this.listDatas.filter((data) => {
        return data.name.match(this.searchKey);
      })
    },
    onClearSearch: function() {
      this.searchKey = '';
      this.filterDatas = this.listDatas;
    }
  }
};
</script>

<style lang="scss" scoped>
.table-hover {
  cursor: pointer;
}
.bg {
  font-family: "微軟正黑體";
  background-image: url("../assets/tnu_bg.jpg");
  height: 100vh;
  overflow: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
</style>